import { CARD_BG_COLORS, CARD_BORDER } from "../card/types"

export const SKELETON_FONT_SIZES = {
  "5xl": "--font-size-5xl",
  "4xl": "--font-size-4xl",
  "3xl": "--font-size-3xl",
  "2xl": "--font-size-2xl",
  xl: "--font-size-xl",
  l: "--font-size-l",
  m: "--font-size-m",
  s: "--font-size-s",
  xs: "--font-size-xs",
} as const

export type SkeletonFontSizeType = keyof typeof SKELETON_FONT_SIZES

export const SKELETON_LINE_HEIGHT = {
  large: "--line-height-large",
  medium: "--line-height-medium",
  small: "--line-height-small",
} as const

export type SkeletonLineHeightType = keyof typeof SKELETON_LINE_HEIGHT

export const SKELETON_BG_COLORS = CARD_BG_COLORS
export const SKELETON_BORDER = CARD_BORDER

export type SkeletonBgColorsType = keyof typeof SKELETON_BG_COLORS
export type SkeletonBorderType = keyof typeof SKELETON_BORDER

// New shape variants for better semantic meaning
export const SKELETON_SHAPES = {
  rectangle: "shape-rectangle",
  circle: "shape-circle",
  rounded: "shape-rounded",
  pill: "shape-pill",
} as const

export type SkeletonShapeType = keyof typeof SKELETON_SHAPES

// Animation control
export const SKELETON_ANIMATION = {
  wave: "animation-wave",
  pulse: "animation-pulse",
  none: "animation-none",
} as const

export type SkeletonAnimationType = keyof typeof SKELETON_ANIMATION

// Predefined sizes for common use cases
export const SKELETON_SIZES = {
  avatar: { width: "3rem", height: "3rem", shape: "circle" as const },
  button: { width: "6rem", height: "2.5rem", shape: "rounded" as const },
  text: { width: "100%", height: "1.2em", shape: "rectangle" as const },
  title: { width: "60%", height: "1.5em", shape: "rectangle" as const },
  thumbnail: { width: "4rem", height: "4rem", shape: "rounded" as const },
} as const

export type SkeletonSizeType = keyof typeof SKELETON_SIZES
